import axios from 'axios';
import logger from 'logger';
import last from 'lodash/last';

const config = () => {
  const token = atob(localStorage.getItem('conference-token'));
  let configObject = {};
  if (token) {
    configObject = {
      headers: { Authorization: `${token}` },
    };
  }
  return configObject;
};

export const get = (url) =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get(url, config());
      if (res && res.data && res.data.error) {
        logger.error(`API ERROR: /${url}`, { error: res.data.error });
      } else {
        let response = res.data || {};
        logger.debug(`/${url}`, { response });
      }
      resolve(res);
    } catch (e) {
      logger.error(`API Error: ${url}`, { error: e });
      reject(e);
    }
  });
export const post = (url, data = {}) =>
  new Promise(async (resolve, reject) => {
    try {
      let endpoint = '';
      try {
        endpoint = last(url.split('/'));
      } catch (e) {
        //nothing
      }
      logger.debug(`/${endpoint}`, { payload: { ...data } });
      const res = await axios.post(url, data, config());
      if (res && res.data && res.data.error) {
        logger.error(`API ERROR: /${endpoint}`, { error: res.data.error });
      } else {
        let response = res.data || {};
        logger.debug(`/${endpoint}`, { response });
      }
      resolve(res);
    } catch (e) {
      logger.error(`API Error: ${url}`, { error: e });
      reject(e);
    }
  });
